export default __webpack_public_path__ + "static/ga-8456e5fb252d9269f91349a553bf5eb4.png";